<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

	<span v-html="formatcurrency(value)" v-if="value" />

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	computed: {

		value: function() {

			return (this.item.game.version) ? this.item.game.version.worth.value || this.item.game.worth.value : this.item.game.worth.value

		}

	}

}

</script>

<style scoped>

</style>